import { Schema, model, models, Document, Model } from "mongoose";
import { NetworkSymbols } from "based-auth/networks";
import { UserRole } from "based-shared/types";

export interface IUserMetaInfo {
  website: string;
  twitter: string;
  telegram: string;
  discord: string;
}

export interface IUser {
  name: string;
  network: NetworkSymbols;
  address: string;
  social: string;
  provider: string;
  chainId: number;
  image: string;
  role: UserRole;
}

export interface IUserProfile extends Document {
  _id: string;
  name: string;
  network: NetworkSymbols;
  bio: string;
  address: string;
  social: string;
  image: string;
  banner: string;
  metaInfo: IUserMetaInfo;
  role: UserRole;
  lastNetwork: string;
  lastSignedIn: Date;
  lastAddress: string;
  followers: string[];
  createdAt: Date;
  updatedAt: Date;
  users: IUser[];
}

const userProfileSchema = new Schema(
  {
    bio: {
      type: String,
      default: "",
    },
    banner: {
      type: String,
      default: "",
    },
    userid: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    metaInfo: {
      website: {
        type: String,
        default: "",
      },
      twitter: {
        type: String,
        default: "",
      },
      telegram: {
        type: String,
        default: "",
      },
      discord: {
        type: String,
        default: "",
      },
    },
    lastNetwork: {
      type: String,
      default: "",
    },
    lastSignedIn: {
      type: Date,
      default: Date.now,
    },
    lastAddress: {
      type: String,
      default: "",
    },
    followers: [
      {
        type: Schema.Types.ObjectId,
        ref: "UserProfile",
      },
    ],
    users: [
      {
        name: {
          type: String,
          default: "",
          required: true,
        },
        chainId: {
          type: Number,
          required: true,
        },
        network: {
          type: String,
          enum: Object.values(NetworkSymbols),
          required: true,
        },
        address: {
          type: String,
          required: true,
        },
        social: {
          type: String,
          default: "",
        },
        provider: {
          type: String,
          default: "",
        },
        image: {
          type: String,
          default: "",
          required: true,
        },
        role: {
          type: String,
          default: UserRole.USER,
          enum: Object.values(UserRole),
        },
      },
    ],
  },
  {
    timestamps: true,
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret) => {
        ret.id = ret._id.toString();
        delete ret._id;

        return ret;
      },
    },
  }
);

userProfileSchema.index(
  { "users.network": 1, "users.address": 1 },
  { unique: true }
);

export const UserProfileModel: Model<IUserProfile> =
  models?.UserProfile || model<IUserProfile>("UserProfile", userProfileSchema);
